<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
      >
        <v-alert
          dense
          type="error"
          outlined
          text
          dismissible
          transition="slide-x-transition"
          class="py-0 text-uppercase"
          v-for="(item, index) in updateErrors"
          :key="index"
        >
          {{ item[0] }}
        </v-alert>
        <v-text-field
          label="Unit"
          v-model="unit"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
      >
        <v-text-field
          label="Description"
          v-model="description"
        ></v-text-field>
      </v-col>
      <v-col
        cols="6"
      >
        <v-btn
          color="green"
          block
          :loading="updating"
          @click="initUpdate"
        >Save</v-btn>
      </v-col>
      <v-col
        cols="6"
      >
        <v-btn
          color="red"
          block
          @click="closeDialog"
        >Close</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  export default {
    name: 'vUnitEdit',
    props: {
      propUnitId: {
        type: Number,
        default: null,
      },
      propUnitData: Object,
    },
    data () {
      return {
        unit: null,
        description: null,
      }
    },
    computed: {
      ...mapState({
        updating: state => state.unit.updating,
        updateErrors: state => state.unit.updateErrors,
        updateSuccess: state => state.unit.updateSuccess,
      }),
      unitId () {
        // this.unitIdSideEffects()
        return this.propUnitId
      },
    },
    watch: {
      updateSuccess (val) {
        if (val) {
          this.resetData()
          this.closeDialog()
        }
      },
      propUnitId (val) {
        this.unitIdSideEffects()
      },
    },
    methods: {
      ...mapActions({
        update: 'unit/update',
      }),
      resetData () {
        this.unit = null
        this.description = null
      },
      closeDialog () {
        this.$emit('close-dialog')
      },
      unitIdSideEffects () {
        this.unit = this.propUnitData.unit
        this.description = this.propUnitData.description
      },
      initUpdate () {
        const data = {
          unit: this.unit,
          description: this.description,
        }
        this.update({
          data,
          id: this.unitId,
        })
      },
    },
  }
</script>
